import { render, staticRenderFns } from "./ModalVideoBatchUpload.vue?vue&type=template&id=0454cde7&"
import script from "./ModalVideoBatchUpload.vue?vue&type=script&lang=js&"
export * from "./ModalVideoBatchUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports